import { ChakraProvider } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import useApiFetch from '@/hooks/useApiFetch';
import candidatesServices, { Candidate } from '@/services/candidates';
import { chakraExtendedTheme } from '@/styles/theme';
import { FetchApiIds } from '@/types';
import CandidatesBoardComponent from './CandidatesBoard.component';

const CandidatesBoard = (): JSX.Element => {
  const { state } = useLocation();

  const candidatesBoardResponse = useApiFetch<Record<string, Candidate[]>>(
    FetchApiIds.CANDIDATES_BOARD,
    candidatesServices.getCurrentCandidates
  );

  return (
    <ChakraProvider theme={chakraExtendedTheme}>
      <CandidatesBoardComponent
        isAllCandidates={state.isAllCandidates}
        isLoading={candidatesBoardResponse.isLoading}
        data={candidatesBoardResponse.data}
      />
    </ChakraProvider>
  );
};

export default CandidatesBoard;
